import { Fragment, ReactElement } from 'react';
import RegistrationCivilUnionDetailNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-civil-union/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const RegistrationCivilUnionDetailNotificationsPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCivilUnionDetailNotificationsCivilStatusShared scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

RegistrationCivilUnionDetailNotificationsPage.displayName =
  'Research Civil Union Detail Notifications Page component';

export default RegistrationCivilUnionDetailNotificationsPage;
